export const stringToHtml = data => {
  return { __html: data }
}
